import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../../redux/api";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";
import CompanyFileUpload from "../../Modules/ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import { getDisputePostType, getDisputeSortNamePostType, getPostType } from "../../../assests/extention/commonfunction";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { Tooltip } from "react-tooltip";
import DisputeResponseModal from "./DisputeResponseModal";
import { descriptionvalidation, namevalidation } from "../commonvalidation";
import AsteriskLabel from "../AsteriskLabel";
import { handleNameKeyDown } from "../FewCommonMethods";

const validation = Yup.object().shape({
  name: namevalidation,
  message: descriptionvalidation,
});

const HelpSupportModal = ({
  setTheModal,
  theModal,
  data,
  masterID,
  masterType,
}) => {
  const [disputemodal, setDisputemodal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const nameInputRef = useRef(null);
  const tooltipTimeoutRef = useRef(null);

  const path = "Assets/scss/homepage.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    // Cleanup timeout on unmount
    return () => {
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      message: "",
      files: [],
    },
    validationSchema: validation,
    onSubmit: (values) => handleSubmit(values),
  });

  const handleSubmit = (values) => {
    const data = {
      message: values.message,
      title: values.name,
      files: values.files,
      master_id: masterID,
      master_type: masterType,
    };

    axiosInstance
      .post("contact", data)
      .then((res) => {
        formik.resetForm();
        setTheModal(false);
        urtoast(res.data.response.message, 1);
        setDisputemodal(true)
      })
      .catch((e) => {
        console.log(e.message, "error");
        urtoast(e.message, 2);
      });
  };

  const clearModal = () => {
    setTheModal((state) => !state);
    formik.resetForm();
  };

  const handleNameInputFocus = () => {
    // Close tooltip when input is focused
    if (tooltipOpen) {
      setTooltipOpen(false);
    }
    // Clear any pending tooltip timeout
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }
  };

  const handleTooltipIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Toggle tooltip
    setTooltipOpen(!tooltipOpen);

    // If opening tooltip, focus should not be on input
    if (!tooltipOpen && nameInputRef.current) {
      nameInputRef.current.blur();
    }
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <>
      <Modal isOpen={theModal} toggle={() => clearModal()} className="about-modal create-pop-modal">
        <div className="">
          <button class="btn close-button" onClick={() => setTheModal(false)}><i class="fa-solid fa-xmark"></i></button>
          <div className="welcome-first text-center mx-auto">
            <h3>Dispute</h3>
            <p className="dispute-p">Work type: {getDisputeSortNamePostType(masterType)} {data?.title && <span className="d-block">{data?.title}</span>}</p>
          </div>
          <div className="col-md-12">
            <div className="it-dev">
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-12 form-group">
                    <label htmlFor="name">What do you need help with <AsteriskLabel />{' '}
                      <img
                        data-tooltip-id="my-tooltip-1"
                        src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                        alt="Help icon"
                        onClick={handleTooltipIconClick}
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => {
                          // Optional: Add small delay on hover
                          tooltipTimeoutRef.current = setTimeout(() => {
                            if (!formik.values.name) {
                              setTooltipOpen(true);
                            }
                          }, 300);
                        }}
                        onMouseLeave={() => {
                          if (tooltipTimeoutRef.current) {
                            clearTimeout(tooltipTimeoutRef.current);
                          }
                          // Don't close on mouse leave if user clicked
                          // Only close on mouse leave if not clicked
                        }}
                      /> </label>
                    <div>
                      <input
                        ref={nameInputRef}
                        id="name"
                        name="name"
                        type="text"
                        style={{ width: "100%" }}
                        placeholder="Write here"
                        value={formik.values.name}
                        className="form-control"
                        onChange={formik.handleChange}
                        onFocus={handleNameInputFocus}
                        onKeyDown={handleNameKeyDown}
                        onBlur={() => {
                          // Optional: Close tooltip when input loses focus if tooltip is open
                          if (tooltipOpen) {
                            setTooltipOpen(false);
                          }
                        }}
                      />
                      {formik.errors.name && formik.touched.name && (
                        <p style={{ color: "red" }}>{formik.errors.name}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 form-group">
                    <label htmlFor="message">Describe your issue <AsteriskLabel /></label>
                    <div>
                      <textarea
                        rows="5"
                        style={{ width: "100%" }}
                        id="message"
                        className="form-control"
                        name="message"
                        placeholder="Write here"
                        value={formik.values.message}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.message && formik.touched.message && (
                        <p style={{ color: "red" }}>{formik.errors.message}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 form-group">
                    <label htmlFor="message">Upload file (optional) </label>
                    <CompanyFileUpload formik={formik} name={"files"} />
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="background-button btn buttons mx-auto"
                      style={{
                        padding: '12px 16px',
                        width: 'max-content',
                        display: 'block'
                      }}
                    >Submit Request</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <Tooltip
            id="my-tooltip-1"
            place="top"
            content="In case of a dispute, either party can raise an issue with URXPRT. A platform fee (percentage-based) will be deducted for handling and resolving the dispute, as decided by the admin."
            isOpen={tooltipOpen}
            setIsOpen={setTooltipOpen}
            clickable={true}
            closeOnEsc={true}
            closeOnScroll={true}
            afterHide={handleTooltipClose}
            style={{ zIndex: 9999 }}
          // Add click event to close when clicking outside
          />
        </div>
      </Modal>

      <DisputeResponseModal modal={disputemodal} setModal={setDisputemodal} />
    </>
  );
};

export default HelpSupportModal;